module.exports = __webpack_public_path__ + "fontawesome-webfont.fee66e712a8a08eef580.woff";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = ../../../../../client/assets/fonts/fontawesome-webfont.woff?v=4.7.0
// module chunks = styles